import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { calculateMonatssoll } from '@/domain/mitarbeiter/features/anlageassistent/utils/calculateMonatssoll';
import { Monate } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/monate';
import { cn } from '@/lib/utils';
import { Body, Title } from '@e2n/ui/v2';
import dayjs from 'dayjs';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export function BerechnetesMonatssoll() {
  const { t } = useTranslation();
  const currentYear = dayjs().year();

  const form = useAnlageassistentFormContext();
  const calculatedMonatssoll = useMemo(
    () =>
      calculateMonatssoll({
        tagessoll:
          form.state.values.bezahlung.arbeitszeitkonto.tagessoll ?? '00:00',
        tage: form.state.values.bezahlung.arbeitszeitkonto.arbeitstage ?? [],
      }),
    [
      form.state.values.bezahlung.arbeitszeitkonto.tagessoll,
      form.state.values.bezahlung.arbeitszeitkonto.arbeitstage,
    ],
  );

  return (
    <div className="flex flex-col gap-4">
      <Title>
        {t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.berechnetesMonatssoll.label',
          { year: currentYear },
        )}
      </Title>
      <div className="flex gap-2 justify-start h-full overflow-x-auto">
        {calculatedMonatssoll.map(({ monat, soll }) => (
          <MonatSoll
            key={monat.toString()}
            monat={monat}
            soll={soll}
            className="not-last:border-r not-last:border-separators-non-opaque not-last:pr-4"
          />
        ))}
      </div>
    </div>
  );
}

function MonatSoll({
  monat,
  soll,
  className,
}: {
  monat: Monate[keyof Monate];
  soll: string;
  className?: string;
}) {
  const { t } = useTranslation();
  return (
    <div className={cn('flex flex-col gap-1', className)}>
      <Body size={'sm'} weight={'semibold'} className="text-neutrals-700">
        {t(`general.date.monthsShort.${monat}`)}
      </Body>
      <Body weight={'semibold'}>{soll}</Body>
    </div>
  );
}
